import { BreakoutClock } from "../components/BreakoutClock"

const between = (start, end) => new Date() > new Date(start) && new Date() < new Date(end)

export default {
	backgroundFunction: () => [
		["2021-11-01T08:00+00:00", "https://assets.swoogo.com/uploads/full/1457538-6183fe9cd4203.jpg"],
		["2021-11-18T08:00+00:00", "https://assets.swoogo.com/uploads/full/1466069-618bf3fa5a36b.jpg"],
		["2021-11-18T16:30+00:00", "https://assets.swoogo.com/uploads/full/1466088-618bf4d50eef2.jpg"],
	].sort((a, b) => a[0] < b[0] ? 1 : -1).find(i => new Date(i[0]) < new Date())[1]
	,
	extras: (
		<>
			<iframe
				className="breakouts-livestream"
				src="https://embedplayer.evia.events/tkeventsbreakoutdemo1?autoplay=true&muted=false"
				allowfullscreen
			/>
			<BreakoutClock />
		</>
	),
	links: [
		{
			label: "Q%A",
			width: "11%",
			height: "5.8%",
			left: "46.5%",
			top: "64.8%",
			CometChatID: "ccm",
		},
		{
			label: "Back to Breakout Foyer",
			href: "/breakouts",
			width: "19%",
			height: "5.8%",
			left: "42.5%",
			top: "88.8%",
		},
	],
	name: "breakout-one",
}